/* Spoiled Brat: Amazon Price Label v7 — one label per product card */
(function() {

  function getPrice(container) {
    // Single variant
    var single = container.querySelector('[data-price-compare]');
    if (single) {
      var t = single.textContent.trim();
      if (t && t !== '$0.00') return t;
    }
    // Multi-variant range
    var minEl = container.querySelector('[data-price-compare-min]');
    var maxEl = container.querySelector('[data-price-compare-max]');
    if (minEl && maxEl) {
      var mn = minEl.textContent.trim();
      var mx = maxEl.textContent.trim();
      if (mn && mn !== '$0.00') return (mn === mx) ? mn : mn + '\u2013' + mx;
    }
    return null;
  }

  function applyLabels(root) {
    root = root || document;

    // Find each price block (the outer .price div that wraps everything)
    // Use the .price wrapper to ensure we only inject ONE label per product
    root.querySelectorAll('.price').forEach(function(priceBlock) {
      // Skip hidden containers
      if (priceBlock.closest('.price__compare-at--hidden') ||
          priceBlock.closest('.price__current--hidden') ||
          priceBlock.closest('[data-compare-price-hidden]') ||
          priceBlock.closest('[data-compare-price-range-hidden]')) return;

      // Remove any existing labels in this price block
      priceBlock.querySelectorAll('.sb-al').forEach(function(el){ el.remove(); });

      // Get the compare-at container within this block
      var container = priceBlock.querySelector('[data-price-compare-container]');
      if (!container) return;

      var price = getPrice(container);
      if (!price) return;

      // Build label
      var label = document.createElement('div');
      label.className = 'sb-al';
      label.style.cssText = 'display:block;text-decoration:none!important;margin-bottom:2px;line-height:1.5;';
      label.innerHTML =
        '<span style="font-size:0.82rem;color:#666;">' +
        '\uD83D\uDED2 Amazon charges: <strong style="color:#444;text-decoration:none!important;">' + price + '</strong>' +
        ' &nbsp;&middot;&nbsp; <span style="color:#2a7a2a;font-weight:700;">We charge less</span>' +
        '</span>';

      // Insert at top of the price block (before the compare-at container)
      priceBlock.insertBefore(label, priceBlock.firstChild);
      container.style.display = 'block';
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLabels);
  } else {
    applyLabels();
  }
  setTimeout(applyLabels, 600);

  // Variant changes
  document.addEventListener('variant:changed', function() {
    setTimeout(applyLabels, 150);
  });

  // Quick Shop popup watch
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-price-compare-container]')) {
          setTimeout(function(){ applyLabels(node); }, 250);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
